import { FormEvent, useState } from 'react';
import jsonp from 'jsonp';

import { mailchimpHoneypotField, mailchimpSubscribeUrl } from '../../content';

const MAILCHIMP_URL = process.env.REACT_APP_MAILCHIMP_URL ?? mailchimpSubscribeUrl;

type SubscribeStatus = 'idle' | 'loading' | 'success' | 'error';

type MailchimpResponse = {
  result: string;
  msg: string;
};

export const NewsletterSubscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<SubscribeStatus>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setStatus('loading');
    setMessage('');

    const params = new URLSearchParams({
      EMAIL: email,
      [mailchimpHoneypotField]: '',
    });

    jsonp(`${MAILCHIMP_URL}&${params}`, { param: 'c' }, (err, data: MailchimpResponse) => {
      if (err || data?.result !== 'success') {
        setStatus('error');
        setMessage(data?.msg ?? 'Something went wrong. Please try again.');
        return;
      }

      setStatus('success');
    });
  };

  const isDisabled = status === 'loading' || status === 'success';

  const buttonLabel =
    status === 'success' ? 'Subscribed' : status === 'loading' ? 'Subscribing…' : 'Subscribe';

  return (
    <form className="needs-validation" onSubmit={handleSubmit} noValidate>
      <label className="form-label subscription-title" htmlFor="subscr-email">
        Subscribe to our newsletter
      </label>
      <div className="input-group position-relative">
        <input
          type="email"
          id="subscr-email"
          name="EMAIL"
          className="form-control rounded-start ps-5"
          placeholder="Your email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          disabled={isDisabled}
          aria-invalid={status === 'error'}
        />
        <i className="bx bx-envelope fs-lg text-muted position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5"></i>
        <input
          type="text"
          name={mailchimpHoneypotField}
          tabIndex={-1}
          autoComplete="off"
          className="newsletter-honeypot"
          aria-hidden="true"
          defaultValue=""
        />
        <button type="submit" className="btn btn-primary" disabled={isDisabled}>
          {buttonLabel}
        </button>
      </div>
      {status === 'error' && message && (
        <p className="newsletter-error mb-0 mt-2" role="alert">
          {message}
        </p>
      )}
    </form>
  );
};
